export enum CloudFoldersEnum {
  Recent = 'RECENT',
  Myfiles = 'MYFILES',
  Shared = 'SHARED',
  Favorites = 'FAVORITES'
}
